import { HttpClient } from '@angular/common/http';
import { Component, inject, OnInit, signal, Signal } from '@angular/core'
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionUpdateRequest } from 'src/app/shared/session/session-update-request.model';
@Component({
    selector: 'app-teststripe',
    templateUrl: './teststripe.component.html',
    styleUrls: ['./teststripe.component.scss'],
    imports: [FormsModule]
})
export class TestStripeComponent implements OnInit {
    isSuccess: boolean = false;
    isFailure: boolean = false;
    sessionId : string = '';
    stripePaymentId = signal("");
    stripeStatus = signal("");
    private http = inject(HttpClient)
    private route = inject(ActivatedRoute);
    
    constructor() {
        this.route.queryParams.subscribe(params => {
            const success = params['success'];
            if (success === 'true') {
                this.isSuccess = true;
                // console.log('Payment successful!');
            } else if (success === 'false') {
                this.isFailure = true;
                // console.log('Payment failed or was cancelled.');
            } else {
                // console.log('No payment status found in query parameters.');
            }
            this.sessionId = params['userSessionId'] || '';
        });
    }

    ngOnInit(): void {
        this.http.get<SessionUpdateRequest>("api/session/get").subscribe((response) => {
            
            if(response?.wizardData?.step06){
                this.stripePaymentId.set(response.wizardData.step06.stripeId ?? "null");
                this.stripeStatus.set(response.wizardData.step06.status ?? "null");
            }
        });
    }

    

}

